import Page from 'components/modules/public/pages/Job';
export default Page;